module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_6.b887fa00.pdf";